import { createClient } from '@sanity/client'

const projectId = process.env.SANITY_PROJECT_ID || 'ksbd2rdi'
const dataset = process.env.SANITY_DATASET || 'production'
const token = process.env.SANITY_API_TOKEN

export const apiVersion = '2021-03-25'

export const client = createClient({
  projectId,
  dataset,
  useCdn: false,
  token,
  apiVersion: 'v2021-03-25',
})

export function stripDraftsPrefix(docId?: string) {
  return docId?.replace(/^drafts\./, '') ?? ''
}
